var urlUtils = require("./urlUtils");
import { DEFAULT_SORT_RULE, DEFAULT_SORT_RULE_CATEGORY, SEARCH_DEFAULT_SORT_RULE } from "../utilities/constants";
import { getNewProductQtyMap } from "../utilities/ProductQtyMap";

/**
 * Updates the URL history
 * @param {string} start - the 'start' parameter value
 * @param {string} srule - the sorting rule parameter value
 */
const updateHistory = (start, srule, filters, queryString = location.href) => {
    let newURL = $(".permalink").val();
    let pathRefinementsListAsFolder = $(".permalink").data("paths") || "";
    let isSearchPage = queryString?.indexOf("q=") !== -1;

    if (isSearchPage || !newURL)
        newURL = location.href;

    // remove all filters before re-creating the URL. Required
    newURL = urlUtils.removeAllFiltersFromUrl(newURL);

    if (start >= 0) {
        newURL = urlUtils.updateQueryParameter(newURL, "start", start);
    }

    if (srule && srule != DEFAULT_SORT_RULE && srule != DEFAULT_SORT_RULE_CATEGORY && srule != SEARCH_DEFAULT_SORT_RULE && filters && filters.length) {
        newURL = urlUtils.updateQueryParameter(newURL, "srule", srule);
    }

    let URLRefinementsList = pathRefinementsListAsFolder ? pathRefinementsListAsFolder.split(",") : [];
    let hasActiveRefinements = false;

    if (filters) {
        let i = 1;
        filters.forEach(filter=>{
            if (filter.key == "isPromo" && !isSearchPage) {
                if (newURL.indexOf("/true") !== -1) {
                    let promoSlug = $("[data-refinement-type='isPromo']")?.data("label") || "com-desconto-poupanca";

                    newURL = newURL.replace("/true", "/"+promoSlug+"");
                }
                hasActiveRefinements = true;
            } else if (filter.key === "pmin" || filter.key === "pmax") {
                if (filter.key === "pmin" && newURL.indexOf("pmax") > -1 && newURL.indexOf("pmin") === -1) {
                    newURL = urlUtils.insertBeforeLastOccurrence(newURL, "pmax", "pmin=" + filter.value + "&");
                } else {
                    newURL = urlUtils.updateQueryParameter(newURL, filter.key, filter.value);
                }
            } else if (filter.key!="sz" && filter.key != "q" && (filter.key !== "prefn1" && filter.value !== "prefn1")) {
                const showAsFolderInURL = URLRefinementsList.some(refinID => filter.key === refinID.trim());

                if (!showAsFolderInURL || isSearchPage) {
                    newURL = urlUtils.updateQueryParameter(newURL, `prefn${i}`, filter.key);
                    newURL = urlUtils.updateQueryParameter(newURL, `prefv${i}`, filter.value);
                }

                hasActiveRefinements = true;
                i++;
            }


        });

        if (hasActiveRefinements) newURL = urlUtils.updateQueryParameter(newURL, "fcr", "true"); // This parameter identifies when filters are active folder or parameters wise
    }

    if (location.href.indexOf("search-button") > 0 || getDefaultPath(decodeURI(location.href)) == newURL) {
        history.replaceState({}, "", newURL);
    } else if (decodeURI(location.href) != newURL) {
        history.pushState({}, "", newURL);
    }
};

/**
 * Gets the applied search default filters from the url
 * @param {string} url - current url
 * @returns {string} - url with default filters
 */
const getDefaultPath = url => {
    url = urlUtils.updateQueryParameter(url, "start", 0);
    url = urlUtils.updateQueryParameter(url, "pmin", 0.01);

    return url;
};

/**
 * Gets the applied search filters from the url
 * @param {string} url - search url
 * @returns {array} - array of filters objects
 */
const getFiltersFromUrl = url => {
    let filters = [];
    let urlParams = new URLSearchParams(url);
    let keys = urlParams.keys();
    let i = 1;
    for (let key of keys) {

        if (key != "srule" && key != "start" && key.indexOf("Search-UpdateGrid") == -1 && key.indexOf("prefv") < 0) {
            if (key.indexOf("prefn") >= 0) {
                filters.push({
                    key: urlUtils.getURLParameter(url, key),
                    value: urlUtils.getURLParameter(url, "prefv" + i)
                });
                i++;
            } else {
                filters.push({
                    key: key,
                    value: urlUtils.getURLParameter(url, key)
                });
            }
        }
    }

    return filters;
};

/**
 * Handle tile syncronization
 */
const handleTileSync = () => {
    const productQtyMap = getNewProductQtyMap();
    if (parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
        $("body").trigger("product:syncTileData", productQtyMap);
    }
};

export { updateHistory, getFiltersFromUrl, handleTileSync };

